import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a62b5042"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list-overlay d-flex flex-column justify-content-between" }
const _hoisted_2 = { class: "h-100 d-flex flex-column justify-content-start" }
const _hoisted_3 = { class: "button-container d-flex flex-column justify-content-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FbxButton = _resolveComponent("FbxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _renderSlot(_ctx.$slots, "main-content", {}, undefined, true)
    ]),
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.acceptText !== '')
          ? (_openBlock(), _createBlock(_component_FbxButton, {
              key: 0,
              "button-text": _ctx.acceptText,
              theme: _ctx.acceptTheme,
              "show-loading": _ctx.confirmationLoading,
              disabled: _ctx.confirmationLoading,
              onClick: _ctx.acceptClicked
            }, null, 8, ["button-text", "theme", "show-loading", "disabled", "onClick"]))
          : _createCommentVNode("", true),
        (_ctx.rejectText !== '')
          ? (_openBlock(), _createBlock(_component_FbxButton, {
              key: 1,
              "button-text": _ctx.rejectText,
              theme: _ctx.rejectTheme,
              "show-loading": _ctx.rejectionLoading,
              disabled: _ctx.rejectionLoading,
              onClick: _ctx.rejectClicked
            }, null, 8, ["button-text", "theme", "show-loading", "disabled", "onClick"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}